
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

import { mapActions } from 'vuex'
import addressIcon from 'assets/icons/mrdz.png'
import editIcon from 'assets/icons/edit.png'
import chooseIcon from 'assets/icons/icon-choose@3x.png'
import selectedIcon from 'assets/icons/icon-choose-selected@3x.png'

export default {
name: 'AddressCard',
components: {
Swipeout,
SwipeoutItem,
SwipeoutButton,
},

data() {
return {
addressIcon,
editIcon,
chooseIcon,
selectedIcon,
}
},

props: ['address', 'selected', 'type'],

methods: {
...mapActions(['fetchUserAddressByUserId']),
deleteAddress(id) {
const self = this
const req = {
id,
}
this.$http.post('/api/user/deleteAddress', req).then(res => res.json())
.then(() => {
this.fetchUserAddressByUserId(this.$jwt.userId)
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
phoneSeparated(phoneNumber) {
phoneNumber = `${phoneNumber.substring(0, 3)}****${phoneNumber.substring(7, 11)}`
return phoneNumber
},
},
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/AddressCard.vue